import { useState, useEffect } from 'react';
import { getPortfolioDetail } from '@/services/api';
import { useDashboardStore } from '@/stores/useDashboardStore';
import type { PortfolioMetrics, Period } from '@/types/metrics';
import type { NodeSummary } from '@/types/node';

interface PortfolioDetail extends PortfolioMetrics {
  nodes: NodeSummary[];
  uptimeTrend: { time: string; uptimePercent: number | null }[];
}

export function usePortfolioDetail(portfolio: string, period: Period = '24h') {
  const [data, setData] = useState<PortfolioDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const refreshKey = useDashboardStore((s) => s.refreshKey);

  useEffect(() => {
    async function fetch() {
      try {
        setLoading(true);
        const response = await getPortfolioDetail(portfolio, period);
        setData(response);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch portfolio detail'));
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, [portfolio, period, refreshKey]);

  return { data, loading, error };
}
